const CondicionComercialEnum = {
    CONTADO: {
        coc_id: 1,
        coc_descripcion: "CONTADO",
        coc_codigo: "CONTADO"
    },
    CREDITO: {
        coc_id: 2,
        coc_descripcion: "CREDITO",
        coc_codigo: "CREDITO"
    },
    ADELANTO: {
        coc_id: 5,
        coc_descripcion: "ADELANTO",
        coc_codigo: "ADELANTO"
    },
    ADELANTO_50: {
        coc_id: 3,
        coc_descripcion: "ADELANTO 50%",
        coc_codigo: "ADELANTO_50%"
    },
    ADELANTO_15: {
        coc_id: 4,
        coc_descripcion: "ADELANTO 15%",
        coc_codigo: "ADELANTO_15%"
    },
}

export default CondicionComercialEnum